/**
 * FreeformRubricView — Parsed Feedback view for runs whose prompt declares
 * `outputSchemaType: 'FreeformRubricV1'`. Admin-debug wrapper around the
 * canonical `FreeformRubricAnalysis` schema view. Adds the admin-only
 * cross-check block (student answer, correct answer, confidence) — the correct
 * answer is the question's authoritative value, shown next to the LLM's output.
 */
import type { Feedback } from '@padcanvas/shared';
import { FreeformRubricAnalysis } from '../solution-analysis';
import { AdminCrossCheckFields, type SolutionLearningMoment, type RejectMomentHandler } from './AdminCrossCheckFields';

interface Props {
    feedback: Feedback;
    question?: { correctAnswer?: string };
    learningMoments?: SolutionLearningMoment[];
    onRejectMoment?: RejectMomentHandler;
}

export function FreeformRubricView({ feedback, question, learningMoments, onRejectMoment }: Props) {
    return (
        <div className="feedback-content">
            <FreeformRubricAnalysis feedback={feedback} />
            <AdminCrossCheckFields feedback={feedback} question={question} learningMoments={learningMoments} onRejectMoment={onRejectMoment} />
        </div>
    );
}
